import { Box, Typography } from '@mui/material';
import AddProductCard from 'components/shared/CustomDashboard/KeyDealsTab/DealFormField/AddProductCard';
import { useEffect, useRef, useState } from 'react';
import { DealsService } from 'service/deals.service';
import zeplinColor from 'theme/Color';

const DealsAddProductFormField = ({
  handleInputChange,
  value,
  opportunityId,
  pricebookName,
}: {
  handleInputChange: (field: string, value: any, index?: number) => void;
  opportunityId: string;
  pricebookName: string;
  value: any;
}) => {
  console.log({ opportunityId });
  const [products, setProducts] = useState<any[]>([]);
  const [originalProducts, setOriginalProducts] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const previousProductsRef = useRef<any[]>([]);

  const getPricebookProducts = async (pricebookId: string) => {
    try {
      setLoading(true);
      if (!pricebookId || pricebookId === 'none') {
        setLoading(false);
        return;
      }

      const res = await DealsService.getPricebookProducts(pricebookId);
      const productsList = res?.products || res || [];

      setOriginalProducts(productsList);

      if (value?.products && value.products.length > 0) {
        const mergedProducts = value.products.map((entry: any) => {
          const originalProduct = productsList.find(
            (p: any) => (p?.PricebookEntryId || p?.id) === (entry?.PricebookEntryId || entry?.id),
          );
          return {
            ...originalProduct,
            ...entry,
            name:
              originalProduct?.name ||
              originalProduct?.ProductName ||
              entry?.name ||
              entry?.ProductName,
            ProductName:
              originalProduct?.ProductName ||
              originalProduct?.name ||
              entry?.ProductName ||
              entry?.name,
          };
        });
        setProducts(mergedProducts);
      } else {
        setProducts(productsList);
        const productEntries = productsList.map((product: any) => ({
          OpportunityId: opportunityId || '',
          PricebookEntryId: product?.PricebookEntryId || product?.id,
          Quantity: '',
          UnitPrice: product?.UnitPrice || product?.unitPrice,
        }));
        handleInputChange('products', productEntries);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const pricebookId = value?.pricebook2Id || value;

    if (!value?.products || !value?.products?.length) {
      if (pricebookId && pricebookId !== 'none') {
        getPricebookProducts(pricebookId);
      }
    } else {
      const hasNames = value.products.some((p: any) => p?.name || p?.ProductName);

      if (!hasNames && pricebookId && pricebookId !== 'none') {
        getPricebookProducts(pricebookId);
      } else if (hasNames) {
        setProducts(value.products);
      } else {
        setProducts(value.products);
      }
    }
  }, [value?.pricebook2Id]);

  useEffect(() => {
    if (!value?.products || value.products.length === 0) {
      previousProductsRef.current = [];
      return;
    }

    const currentProductIds = value.products
      .map((p: any) => p?.PricebookEntryId || p?.id)
      .sort()
      .join(',');
    const previousProductIds = previousProductsRef.current
      .map((p: any) => p?.PricebookEntryId || p?.id)
      .sort()
      .join(',');

    if (
      currentProductIds !== previousProductIds ||
      value.products.length !== previousProductsRef.current.length
    ) {
      if (originalProducts.length > 0) {
        const mergedProducts = value.products.map((entry: any) => {
          const originalProduct = originalProducts.find(
            (p: any) => (p?.PricebookEntryId || p?.id) === (entry?.PricebookEntryId || entry?.id),
          );
          return {
            ...originalProduct,
            ...entry,
            name:
              originalProduct?.name ||
              originalProduct?.ProductName ||
              entry?.name ||
              entry?.ProductName,
            ProductName:
              originalProduct?.ProductName ||
              originalProduct?.name ||
              entry?.ProductName ||
              entry?.name,
          };
        });
        setProducts(mergedProducts);
        previousProductsRef.current = mergedProducts;
      } else {
        setProducts(value.products);
        previousProductsRef.current = value.products;
      }
    } else {
      setProducts((prevProducts) => {
        return prevProducts.map((prevProduct, index) => {
          const updatedProduct = value.products[index];
          if (
            updatedProduct &&
            (prevProduct?.PricebookEntryId || prevProduct?.id) ===
              (updatedProduct?.PricebookEntryId || updatedProduct?.id)
          ) {
            return {
              ...prevProduct,
              Quantity: updatedProduct.Quantity,
              UnitPrice: updatedProduct.UnitPrice,
              SalesPrice: updatedProduct.SalesPrice,
            };
          }
          return prevProduct;
        });
      });
    }
  }, [value?.products, originalProducts]);

  return (
    <Box sx={{ display: 'flex', gap: '24px', flexDirection: 'column' }}>
      <Box sx={{ display: 'flex', gap: '16px', flexDirection: 'column' }}>
        <Typography variant='heading4'>Add Products</Typography>
        <Typography variant='body2' color={zeplinColor.Neutral9}>
          Price book: {pricebookName} Price Book
        </Typography>
        {loading === true
          ? [1, 2, 3, 4].map((val) => (
              <AddProductCard
                data={val}
                index={val}
                handleInputChange={handleInputChange}
                value={val}
                loading={true}
                pricebookName=''
              />
            ))
          : ''}
        {products?.length
          ? products?.map((val, index) => (
              <AddProductCard
                data={val}
                index={index}
                handleInputChange={handleInputChange}
                value={value}
                loading={false}
                pricebookName={pricebookName}
              />
            ))
          : ''}
      </Box>
    </Box>
  );
};

export default DealsAddProductFormField;
